/* tslint:disable:max-file-line-count */

export const iconSemantics: Record<string, string[]> = {
    // Weather & Winter
    snow: [
        'cloudy_snowing',
        'snowing',
        'sunny_snowing',
        'snowboarding',
        'snowmobile',
        'snowshoeing',
        'downhill_skiing',
        'ice_skating',
        'ac_unit',
        'severe_cold',
    ],
    winter: [
        'cloudy_snowing',
        'snowing',
        'sunny_snowing',
        'snowboarding',
        'snowmobile',
        'snowshoeing',
        'downhill_skiing',
        'ice_skating',
        'ac_unit',
        'severe_cold',
    ],
    cold: ['severe_cold', 'ac_unit', 'ice_skating', 'cloudy_snowing', 'snowing'],
    ice: ['ice_skating', 'icecream', 'cloudy_snowing', 'snowing'],
    ski: ['downhill_skiing', 'snowboarding', 'snowshoeing', 'snowmobile'],
    weather: ['cloudy_snowing', 'sunny_snowing', 'snowing', 'wb_sunny', 'wb_cloudy', 'wb_twilight', 'thunderstorm', 'rainy', 'ac_unit'],
    cloud: [
        'cloudy_snowing',
        'wb_cloudy',
        'cloud',
        'cloud_queue',
        'cloud_done',
        'cloud_download',
        'cloud_upload',
        'cloud_off',
        'cloud_circle',
    ],
    rain: ['rainy', 'thunderstorm', 'water_drop', 'umbrella'],
    sun: ['wb_sunny', 'sunny_snowing', 'light_mode', 'brightness_high', 'brightness_low'],
    storm: ['thunderstorm', 'rainy', 'cloudy_snowing'],

    // Sports & Activities
    sports: [
        'sports',
        'sports_baseball',
        'sports_basketball',
        'sports_cricket',
        'sports_esports',
        'sports_football',
        'sports_golf',
        'sports_gymnastics',
        'sports_handball',
        'sports_hockey',
        'sports_kabaddi',
        'sports_martial_arts',
        'sports_mma',
        'sports_motorsports',
        'sports_rugby',
        'sports_soccer',
        'sports_tennis',
        'sports_volleyball',
        'downhill_skiing',
        'snowboarding',
        'ice_skating',
        'snowshoeing',
        'snowmobile',
        'pool',
        'golf_course',
        'fitness_center',
        'directions_run',
        'directions_bike',
        'directions_walk',
    ],
    soccer: ['sports_soccer', 'sports_football'],
    basketball: ['sports_basketball'],
    football: ['sports_football', 'sports_soccer'],
    tennis: ['sports_tennis'],
    golf: ['golf_course', 'sports_golf'],
    swimming: ['pool', 'water', 'beach_access'],
    running: ['directions_run', 'fitness_center'],
    walk: ['directions_walk'],

    // Technology & Devices
    computer: ['computer', 'laptop', 'desktop_windows', 'desktop_mac'],
    laptop: ['laptop', 'laptop_mac', 'laptop_windows', 'laptop_chromebook'],
    phone: [
        'phone',
        'phone_android',
        'phone_iphone',
        'smartphone',
        'call',
        'call_made',
        'call_received',
        'call_end',
        'call_merge',
        'call_split',
    ],
    mobile: ['phone', 'phone_android', 'phone_iphone', 'smartphone'],
    device: ['devices', 'devices_other', 'devices_fold', 'device_hub', 'device_thermostat', 'device_unknown', 'important_devices'],
    tech: ['computer', 'laptop', 'phone', 'tablet', 'devices', 'memory', 'storage'],
    tablet: ['tablet', 'tablet_android', 'tablet_mac'],

    // Communication
    message: ['message', 'chat', 'chat_bubble', 'chat_bubble_outline', 'comment', 'forum', 'question_answer'],
    chat: ['chat', 'chat_bubble', 'chat_bubble_outline', 'forum', 'question_answer'],
    email: ['email', 'mail', 'mail_outline', 'mark_email_read', 'mark_email_unread', 'drafts'],
    mail: ['email', 'mail', 'mail_outline'],
    call: ['call', 'phone', 'call_made', 'call_received', 'call_end', 'phone_in_talk', 'phone_callback'],
    talk: ['chat', 'message', 'forum', 'record_voice_over', 'voice_chat'],
    notification: ['notifications', 'notifications_active', 'notifications_none', 'notifications_off'],
    bell: ['notifications', 'notifications_active', 'notifications_none', 'notifications_off'],

    // Time & Calendar
    time: ['access_time', 'schedule', 'timer', 'alarm', 'watch', 'watch_later', 'hourglass_empty', 'hourglass_full'],
    clock: ['access_time', 'schedule', 'watch', 'watch_later', 'alarm'],
    timer: ['timer', 'timer_off', 'timer_10', 'timer_3'],
    watch: ['watch', 'watch_later'],
    calendar: ['calendar_today', 'calendar_month', 'event', 'event_note', 'date_range'],
    date: ['calendar_today', 'calendar_month', 'date_range', 'event'],
    schedule: ['schedule', 'event', 'event_note', 'calendar_today'],
    alarm: ['alarm', 'alarm_on', 'alarm_off', 'alarm_add', 'access_alarm'],

    // Food & Drink
    food: [
        'restaurant',
        'restaurant_menu',
        'dining',
        'local_dining',
        'fastfood',
        'lunch_dining',
        'dinner_dining',
        'breakfast_dining',
        'bakery_dining',
        'set_meal',
    ],
    restaurant: ['restaurant', 'restaurant_menu', 'local_dining', 'dining'],
    meal: ['restaurant', 'dining', 'set_meal', 'lunch_dining', 'dinner_dining', 'breakfast_dining'],
    eat: ['restaurant', 'dining', 'local_dining'],
    drink: ['local_drink', 'local_bar', 'wine_bar', 'coffee', 'local_cafe', 'liquor'],
    coffee: ['coffee', 'local_cafe', 'coffee_maker'],
    tea: ['local_cafe', 'coffee'],
    water: ['water_drop', 'local_drink', 'beach_access', 'pool'],
    cake: ['cake', 'bakery_dining', 'celebration'],
    pizza: ['local_pizza'],
    burger: ['lunch_dining', 'fastfood'],

    // Transportation
    car: ['directions_car', 'car_rental', 'car_repair', 'local_taxi'],
    vehicle: ['directions_car', 'directions_bus', 'train', 'flight', 'directions_boat', 'two_wheeler', 'pedal_bike'],
    drive: ['directions_car', 'drive_eta'],
    transport: ['directions_car', 'directions_bus', 'train', 'flight', 'directions_boat', 'directions_transit'],
    airplane: ['flight', 'flight_takeoff', 'flight_land', 'airplane_ticket'],
    plane: ['flight', 'flight_takeoff', 'flight_land'],
    flight: ['flight', 'flight_takeoff', 'flight_land', 'airplane_ticket'],
    travel: ['flight', 'train', 'directions_car', 'directions_bus', 'directions_boat', 'hotel', 'luggage'],
    bus: ['directions_bus', 'bus_alert'],
    train: ['train', 'directions_railway', 'subway'],
    bike: ['directions_bike', 'pedal_bike', 'bike_scooter', 'two_wheeler'],
    boat: ['directions_boat'],
    taxi: ['local_taxi'],

    // Music & Entertainment
    music: ['music_note', 'music_off', 'music_video', 'library_music', 'queue_music'],
    song: ['music_note', 'library_music', 'queue_music'],
    audio: ['volume_up', 'volume_down', 'volume_off', 'volume_mute', 'hearing', 'headphones'],
    sound: ['volume_up', 'volume_down', 'volume_off', 'volume_mute', 'hearing'],
    play: ['play_arrow', 'play_circle', 'play_circle_outline', 'play_circle_filled'],
    video: ['videocam', 'videocam_off', 'video_library', 'video_call', 'movie'],
    media: ['music_note', 'video_library', 'movie', 'image'],
    movie: ['movie', 'movie_filter', 'local_movies'],
    camera: ['camera', 'camera_alt', 'camera_enhance', 'camera_roll', 'photo_camera', 'photo_library'],
    photo: ['photo', 'photo_camera', 'photo_library', 'photo_size_select_actual', 'add_a_photo'],

    // Work & Business
    work: ['work', 'work_outline', 'business', 'business_center', 'briefcase', 'folder', 'folder_open'],
    business: ['business', 'business_center', 'work', 'briefcase', 'corporate_fare'],
    office: ['business_center', 'work', 'corporate_fare'],
    job: ['work', 'business', 'briefcase'],
    briefcase: ['briefcase', 'work', 'business'],
    folder: ['folder', 'folder_open', 'folder_shared', 'folder_special'],
    file: ['description', 'insert_drive_file', 'text_snippet', 'article'],

    // Health & Medical
    health: ['health_and_safety', 'medical_services', 'local_hospital', 'healing', 'medication'],
    medical: ['medical_services', 'local_hospital', 'healing', 'medication', 'medical_information'],
    hospital: ['local_hospital', 'medical_services'],
    doctor: ['medical_services', 'local_hospital', 'person', 'person_outline'],
    medicine: ['medication', 'medication_liquid', 'healing'],
    fitness: ['fitness_center', 'directions_run', 'self_improvement', 'sports_gymnastics'],
    exercise: ['fitness_center', 'directions_run', 'directions_bike', 'pool'],

    // Education
    school: ['school', 'local_library', 'menu_book', 'book', 'auto_stories'],
    education: ['school', 'local_library', 'menu_book', 'book'],
    learn: ['school', 'menu_book', 'book', 'auto_stories', 'local_library'],
    study: ['menu_book', 'book', 'auto_stories', 'local_library', 'school'],
    student: ['school', 'person', 'groups'],
    book: ['book', 'menu_book', 'auto_stories', 'library_books', 'local_library'],
    read: ['menu_book', 'book', 'auto_stories', 'local_library'],
    library: ['local_library', 'library_books', 'library_music', 'library_add'],

    // Home & Living
    home: ['home', 'home_work', 'home_max', 'home_mini', 'home_repair_service'],
    house: ['home', 'home_work', 'cottage', 'villa'],
    residence: ['home', 'home_work', 'cottage'],
    living: ['home', 'living', 'room_preferences'],
    room: ['room', 'room_service', 'room_preferences', 'bedroom_parent', 'bedroom_child', 'bedroom_baby'],
    bedroom: ['bedroom_parent', 'bedroom_child', 'bedroom_baby'],
    kitchen: ['kitchen'],
    bathroom: ['bathroom'],

    // Shopping & Money
    trolley: ['shopping_cart', 'local_shipping', 'airport_shuttle'],
    shop: ['store', 'shopping_cart', 'shopping_bag', 'local_grocery_store', 'storefront'],
    store: ['store', 'storefront', 'local_grocery_store', 'shopping_cart'],
    buy: ['shopping_cart', 'add_shopping_cart', 'store', 'payment'],
    purchase: ['shopping_cart', 'payment', 'receipt', 'store'],
    shopping: ['shopping_cart', 'shopping_bag', 'add_shopping_cart', 'store'],
    money: ['attach_money', 'money_off', 'payments', 'account_balance_wallet', 'currency_exchange'],
    cash: ['attach_money', 'money_off', 'payments'],
    dollar: ['attach_money', 'payments', 'currency_exchange'],
    payment: ['payment', 'payments', 'credit_card', 'account_balance_wallet'],
    credit_card: ['credit_card', 'card_membership', 'account_balance_wallet'],
    wallet: ['account_balance_wallet'],

    // Emotions & Feelings
    love: ['favorite', 'favorite_border', 'favorite_outline', 'heart_broken'],
    heart: ['favorite', 'favorite_border', 'favorite_outline', 'heart_broken'],
    favorite: ['favorite', 'favorite_border', 'favorite_outline'],
    like: ['thumb_up', 'thumb_up_off_alt', 'favorite'],
    happy: ['sentiment_satisfied', 'sentiment_very_satisfied', 'mood', 'mood_bad'],
    smile: ['sentiment_satisfied', 'sentiment_very_satisfied', 'mood'],
    joy: ['sentiment_very_satisfied', 'celebration', 'party_mode'],
    sad: ['sentiment_dissatisfied', 'sentiment_very_dissatisfied', 'mood_bad'],
    angry: ['sentiment_very_dissatisfied', 'mood_bad'],
    emotion: ['mood', 'mood_bad', 'sentiment_satisfied', 'sentiment_dissatisfied'],

    // Tools & Utilities
    tool: ['build', 'construction', 'handyman', 'settings', 'tune'],
    wrench: ['build', 'construction', 'handyman'],
    repair: ['build', 'construction', 'handyman', 'home_repair_service'],
    fix: ['build', 'construction', 'handyman'],
    settings: ['settings', 'settings_applications', 'tune', 'build'],
    gear: ['settings', 'settings_applications', 'tune'],

    // Security & Safety
    security: ['security', 'lock', 'lock_outline', 'shield', 'verified', 'admin_panel_settings'],
    lock: ['lock', 'lock_outline', 'lock_open', 'lock_clock'],
    shield: ['shield', 'security', 'verified_user'],
    protect: ['security', 'shield', 'verified_user', 'admin_panel_settings'],
    safe: ['security', 'lock', 'shield'],
    key: ['vpn_key', 'key', 'lock'],
    password: ['lock', 'vpn_key', 'key'],

    // Nature & Environment
    nature: ['park', 'forest', 'tree', 'eco', 'nature_people', 'grass'],
    tree: ['park', 'forest', 'nature_people'],
    flower: ['local_florist', 'spa'],
    plant: ['eco', 'local_florist', 'grass'],
    leaf: ['eco', 'local_florist'],
    forest: ['park', 'forest', 'nature_people'],
    park: ['park', 'forest'],
    garden: ['local_florist', 'yard', 'grass'],

    // Animals
    animal: ['pets', 'cruelty_free'],
    dog: ['pets'],
    cat: ['pets'],
    bird: ['pets'],
    fish: ['pets'],
    pet: ['pets'],

    // Colors & Art
    color: ['palette', 'color_lens', 'invert_colors', 'format_color_fill', 'format_color_text'],
    palette: ['palette', 'color_lens'],
    paint: ['format_color_fill', 'format_color_text', 'palette', 'brush'],
    art: ['palette', 'brush', 'draw', 'auto_awesome'],
    brush: ['brush', 'format_paint'],
    draw: ['draw', 'brush', 'edit'],

    // Games & Fun
    game: ['sports_esports', 'casino', 'videogame_asset', 'gamepad'],
    fun: ['celebration', 'party_mode', 'confirmation_number', 'local_activity'],
    entertainment: ['sports_esports', 'movie', 'music_note', 'casino'],
    gamepad: ['sports_esports', 'videogame_asset'],
    party: ['party_mode', 'celebration', 'confetti'],
    celebration: ['celebration', 'party_mode', 'confetti'],

    // Science & Research
    science: ['science', 'biotech', 'psychology', 'memory'],
    lab: ['science', 'biotech'],
    experiment: ['science', 'biotech'],
    research: ['science', 'biotech', 'psychology'],
    microscope: ['biotech', 'science'],

    // Energy & Power
    energy: ['battery_full', 'battery_charging_full', 'bolt', 'flash_on', 'power'],
    battery: ['battery_full', 'battery_charging_full', 'battery_std', 'battery_unknown', 'battery_alert'],
    power: ['power', 'power_settings_new', 'power_off', 'bolt', 'flash_on'],
    electric: ['bolt', 'flash_on', 'electrical_services', 'power'],
    lightning: ['bolt', 'flash_on'],
    charge: ['battery_charging_full', 'bolt'],

    // People & Social
    person: ['person', 'person_outline', 'person_add', 'people', 'groups'],
    people: ['people', 'groups', 'person', 'person_outline'],
    user: ['person', 'person_outline', 'account_circle'],
    account: ['account_circle', 'account_box', 'person', 'person_outline'],
    group: ['groups', 'people', 'group'],
    team: ['groups', 'people', 'group'],

    // Location & Places
    location: ['location_on', 'location_off', 'place', 'my_location', 'add_location'],
    place: ['place', 'location_on', 'location_city'],
    map: ['map', 'map_outlined', 'explore', 'near_me'],
    gps: ['my_location', 'gps_fixed', 'gps_not_fixed'],
    city: ['location_city', 'apartment', 'business'],

    // Weather (additional)
    temperature: ['device_thermostat', 'ac_unit', 'wb_sunny', 'severe_cold'],
    thermostat: ['device_thermostat', 'ac_unit'],
};

export const getIconKeywords = (iconName: string): string[] => {
    const keywords: string[] = [iconName]; // Always include the icon name itself

    if (iconSemantics[iconName]) {
        keywords.push(...iconSemantics[iconName]);
    }

    Object.entries(iconSemantics).forEach(([searchTerm, iconNames]) => {
        if (iconNames.includes(iconName)) {
            keywords.push(searchTerm);
        }
    });

    return Array.from(new Set(keywords));
};

export const resolveIconFromKeyword = (keyword: string): string | null => {
    const k = keyword.toLowerCase().trim().replace(/\s+/g, '_');
    if (!k) return null;
    const icons = iconSemantics[k];
    if (icons?.length) return icons[0];
    if (Object.values(iconSemantics).flat().includes(k)) return k;
    return null;
};

export const matchesSemantically = (iconName: string, searchTerm: string): boolean => {
    const searchLower = searchTerm.toLowerCase();

    if (iconSemantics[searchLower]) {
        return iconSemantics[searchLower].includes(iconName);
    }

    const keywords = getIconKeywords(iconName);
    return keywords.some(keyword => keyword.toLowerCase().includes(searchLower));
};
